import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

const rootElement = document.getElementById('root')!;

// For SEO and meta tags support
const Application = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

createRoot(rootElement).render(<StrictMode>{Application}</StrictMode>);